import { createAddOnRecord } from '../addOnsUtil';
import { getHookCheckoutItems } from '../pages/cartPageInjector/utils';
import { getAppProps, isCartPage, isProductPage } from '../utils';

export function isItemProductExists(item) {
  const { productId, variantId } = item;

  if (isCartPage()) {
    const items = getHookCheckoutItems();

    if (productId && typeof variantId === 'number') {
      if (
        items.find(
          v => v.product_id === productId && v.variant_id === variantId
        )
      ) {
        return true;
      }
    } else {
      if (items.find(v => v.product_id === productId)) {
        return true;
      }
    }

    return false;
  } else {
    // Skip check for product page.
    // We use this for popUp and already have attached to.
    return true;
  }
}

/*
* STRUCTURE EXAMPLE
* 6846871765179|40706905309371
    dark-wall-table|40707005939899: "40707005939899||Desc|20|false"

  product_id|variant_id
  *  name-id|variant_id: variant_id|order|description text|discount|specified.
* */

function getTargetCollection() {
  const details = window.upsell.product.details;
  const availableVariants = details.variants.filter(i => i.available);
  const allVariants = details.variants;
  const id = details.id;
  let selectedVariantId = availableVariants.length
    ? availableVariants[0].id
    : allVariants[0].id;

  const url = new URL(document.URL);
  const isVariantUrl = url.searchParams.get('variant');
  if (isVariantUrl) {
    selectedVariantId = isVariantUrl;
  }

  const product = id;
  const variantId = allVariants.length > 1 ? selectedVariantId : null;

  if (product && variantId) {
    return `${product}|${variantId}`;
  } else {
    return `${product}`;
  }
}

function findIn(addons, item, targetCollection) {
  const { variant_id } = item;

  for (const collection in addons) {
    if (!targetCollection || collection === targetCollection) {
      const itemsPerCollection = addons[collection];
      for (const key in itemsPerCollection) {
        const parsed = createAddOnRecord(itemsPerCollection, key);

        if (parsed.ids.includes(variant_id)) {
          const [productId, variantId] = collection.split('|');

          const ret = parsed;
          ret.productId = parseInt(productId);

          if (variantId) {
            ret.variantId = parseInt(variantId);
          }

          // If attached product exists?
          if (isItemProductExists(ret)) {
            return ret;
          }
        }
      }
    }
  }

  return null;
}

export function getItemFromAddon(addons, item) {
  let targetCollection = null;

  if (isProductPage()) {
    targetCollection = getTargetCollection();
  }

  // Find in everywhere
  let res = findIn(addons, item, targetCollection);

  // Find in catalog
  if (!res) {
    res = findIn(addons.catalog, item);
  }

  // Find in all
  if (!res) {
    res = findIn(addons, item, 'all');
  }

  return res;
}

export function getItemDiscountById(addons, item) {
  const itemAddon = getItemFromAddon(addons, item);

  if (!itemAddon || !itemAddon.discount) return 0;

  return itemAddon.discount;
}

export function getItemDescriptionById(addons, item) {
  const itemAddon = getItemFromAddon(addons, item);

  if (!itemAddon || !itemAddon.description) return '';

  return itemAddon.description || '';
}

export function getItemDiscount(item) {
  const { addOnsDb, popups } = getAppProps();

  // !IMPORTANT: Don't change checking order

  // check in addons
  const discountAddon = getItemDiscountById(addOnsDb, item);
  if (discountAddon > 0) {
    return discountAddon;
  }

  // check in popups
  const discountPopup = getItemDiscountById(popups, item);
  if (discountPopup > 0) {
    return discountPopup;
  }

  return 0;
}

export function getItemFromAnyAddon(item) {
  const { addOnsDb, popups } = getAppProps();

  // !IMPORTANT: Don't change checking order

  // check in addons
  const addonItem = getItemFromAddon(addOnsDb, item);
  if (addonItem) {
    return addonItem;
  }

  // check in popups
  const popupItem = getItemFromAddon(popups, item);
  if (popupItem) {
    return popupItem;
  }

  return null;
}
